import React from 'react';
import './index.css';
import { NavigationItem } from '../../index';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ImageIcon from '@material-ui/icons/Image';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import TuneIcon from '@material-ui/icons/Tune';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import { useUser } from '../../../Context/User';
const Index = ({ close }) => {
    const { role } = useUser();
    return (
        <nav className="dashboard_navigation">
            <NavigationItem
                exact
                close={close}
                Icon={DashboardIcon}
                to="/main"
                activeClassName="active"
                name="Dashboard"
            />
            <NavigationItem
                exact
                close={close}
                Icon={ImageIcon}
                to="/main/imageLibrary"
                activeClassName="active"
                name="Image Library"
            />

            <NavigationItem
                exact
                close={close}
                Icon={AddBoxIcon}
                to="/main/newOrder"
                activeClassName="active"
                name="New order"
            />

            {role === 'admin' && (
                <NavigationItem
                    exact
                    close={close}
                    Icon={FileCopyIcon}
                    to="/main/orders"
                    activeClassName="active"
                    name="Orders"
                />
            )}
            {role === 'merchant' && (
                <NavigationItem
                    close={close}
                    Icon={FileCopyIcon}
                    to="/main/manageOrders"
                    activeClassName="active"
                    name="Manage Orders"
                />
            )}
            {role === 'admin' && (
                <NavigationItem
                    close={close}
                    Icon={PeopleAltIcon}
                    to="/main/manageMerchants"
                    activeClassName="active"
                    name="Merchants"
                />
            )}
            {role === 'admin' && (
                <NavigationItem
                    exact
                    close={close}
                    Icon={AllInboxIcon}
                    to="/main/productLibrary"
                    activeClassName="active"
                    name="Product"
                />
            )}

            {/* {role === 'merchant' && (
                <NavigationItem
                    exact
                    close={close}
                    Icon={EqualizerIcon}
                    to="/main/stockAvaibility"
                    activeClassName="active"
                    name="Stock Availability"
                />
            )} */}
            {role === 'admin' && (
                <NavigationItem
                    exact
                    close={close}
                    Icon={VpnKeyIcon}
                    to="/main/accessManagement"
                    activeClassName="active"
                    name="Access Management"
                />
            )}
            {role === 'merchant' && (
                <NavigationItem
                    close={close}
                    Icon={TuneIcon}
                    to="/main/settings"
                    activeClassName="active"
                    name="Setting"
                />
            )}
            <NavigationItem
                close={close}
                Icon={ReceiptIcon}
                to="/main/Billing"
                activeClassName="active"
                name="Billing"
            />
        </nav>
    );
};

export default Index;
